import React from 'react';
import { Tooltip } from '@mui/material';
import { Link } from 'react-router-dom';

interface ICard {
    key: number;
    svgIcon: React.ReactNode;
    title: string;
    paragraph: string;
    getStarted?: () => void;
    handleTooltipClick?: () => void;
}

const Card: React.FC<ICard> = ({ key, svgIcon, title, paragraph, handleTooltipClick }) => {
  return (
    <>
      <div key={key} className='templates-components'>
        <div className='templates-spacing-div'>
          <div className='templates-comp-div'>
            <div className='module-header-btns-rnd'>
              {svgIcon}
            </div>

            <div className='module-header-btns'>
              <Tooltip
                title={''}
                placement='bottom-start'
                arrow
                onClick={handleTooltipClick}
                componentsProps={{
                  tooltip: {
                    sx: {
                      'display': 'flex',
                      'padding': 'var(--spacing-md, 8px) var(--spacing-lg, 12px)',
                      'flexDirection': 'column',
                      'alignItems': 'flex-start',
                      'alignSelf': 'stretch',
                      'borderRadius': 'var(--radius-md, 8px)',
                      'background': 'var(--Background-200, #202227)',
                      'maxWidth': '700px',
                      '& .MuiTooltip-arrow': {
                        color: 'var(--Background-200, #202227)'
                      }
                    },
                  },
                }}
              >
                <div className='module-header-help'>
                  <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
                    <g clipPath='url(#clip0_16034_866)'>
                      <path d='M7.57484 7.50001C7.77076 6.94306 8.15746 6.47343 8.66647 6.17428C9.17547 5.87514 9.77392 5.76579 10.3558 5.8656C10.9377 5.96541 11.4655 6.26794 11.8457 6.71961C12.226 7.17128 12.4341 7.74294 12.4332 8.33334C12.4332 10 9.93317 10.8333 9.93317 10.8333M9.99984 14.1667H10.0082M18.3332 10C18.3332 14.6024 14.6022 18.3333 9.99984 18.3333C5.39746 18.3333 1.6665 14.6024 1.6665 10C1.6665 5.39763 5.39746 1.66667 9.99984 1.66667C14.6022 1.66667 18.3332 5.39763 18.3332 10Z' stroke='#94969C' strokeWidth='1.66667' strokeLinecap='round' strokeLinejoin='round' />
                    </g>
                    <defs>
                      <clipPath id='clip0_16034_866'>
                        <rect width='20' height='20' fill='white' />
                      </clipPath>
                    </defs>
                  </svg>

                </div>
              </Tooltip>
            </div>
          </div>

          <h1> {title}</h1>

          <p>{paragraph}</p>
        </div>
        {title.includes('Classify Products') ?
          <Link to={{
            pathname: '/bite-classify',
          }}>
            <div className='templates-components-get-started'> Get Started</div>
          </Link> :
          <Link to={{
            pathname: '/create-ticket',
            state: {
              name: title,
            },
          }}>
            <div className='templates-components-get-started'> Get Started</div>
          </Link>}
      </div>
    </>
  );
};

export default Card;
